"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const renderBraintreeHostedField_1 = require("@src/components/modules/forms/renderBraintreeHostedField");
const useBraintree_1 = require("@src/hooks/useBraintree");
const Api = __importStar(require("@src/api"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const EFieldsAttributes = {
    Id: 'Id',
    Label: 'Label',
    ClassName: 'ClassName',
};
const getFieldsConfig = intl => [
    {
        [EFieldsAttributes.Id]: 'card-number',
        [EFieldsAttributes.Label]: intl.formatMessage({
            id: 'global.checkout.card_number',
            defaultMessage: 'Číslo platobnej karty',
        }),
        [EFieldsAttributes.ClassName]: 'col-12',
    },
    {
        [EFieldsAttributes.Id]: 'expiration-date',
        [EFieldsAttributes.Label]: intl.formatMessage({
            id: 'global.checkout.expiration_date',
            defaultMessage: 'Platnosť karty do',
        }),
        [EFieldsAttributes.ClassName]: 'col-6_xs-12',
    },
    {
        [EFieldsAttributes.Id]: 'cvv',
        [EFieldsAttributes.Label]: intl.formatMessage({
            id: 'global.checkout.cvv',
            defaultMessage: 'Bezpečnostný kód (CVC/CVV)',
        }),
        [EFieldsAttributes.ClassName]: 'col-6_xs-12',
    },
];
const AddPaymentMethodModal = ({ setIsAddPaymentMethodModalOpen, isAddPaymentMethodModalOpen }) => {
    const intl = (0, react_intl_1.useIntl)();
    const { isBraintreeLoading, initCheckout, hostedFieldsInstance } = (0, useBraintree_1.useBraintree)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { mutateAsync: createPaymentMethod, isLoading: isCreatingPaymentMethod } = (0, useAppMutation_1.useAppMutation)(async () => {
        const paymentMethodData = await hostedFieldsInstance.tokenize();
        await Api.Admin.createPaymentMethod({ paymentMethodData });
    }, {
        onSuccess: async () => {
            queryClient.invalidateQueries(queries_1.Queries.getPaymentMethods);
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
            setIsAddPaymentMethodModalOpen(false);
        },
    });
    react_1.default.useEffect(() => {
        initCheckout(true);
    }, []);
    const fieldsConfig = getFieldsConfig(intl);
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { centered: true, visible: isAddPaymentMethodModalOpen, onCancel: () => {
            setIsAddPaymentMethodModalOpen(false);
        }, confirmLoading: isCreatingPaymentMethod || isBraintreeLoading, okText: intl.formatMessage({ id: 'admin.payments.add_payment_method' }), onOk: () => createPaymentMethod(), children: (0, jsx_runtime_1.jsx)(StaticHeightDiv, { children: fieldsConfig.map(field => ((0, jsx_runtime_1.jsx)(renderBraintreeHostedField_1.BraintreeHostedField, { "data-cy": field[EFieldsAttributes.Id], id: field[EFieldsAttributes.Id], label: field[EFieldsAttributes.Label], className: field[EFieldsAttributes.ClassName] }, field[EFieldsAttributes.Id]))) }) }));
};
const StaticHeightDiv = styled_components_1.default.div `
	height: 13rem;
	padding: 1rem;
	margin: 1rem;
`;
exports.default = AddPaymentMethodModal;
